import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WebhookShippingComponent } from './components/webhook-shipping/webhook-shipping.component';
import { ReferrerWhitelistComponent } from './components/referrer-whitelist/referrer-whitelist.component';
import { MobileKeyComponent } from './components/mobile-key/mobile-key.component';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  standalone: false,
  selector: 'app-referrer',
  templateUrl: './referrer.component.html',
  styleUrls: ['./referrer.component.scss'],
})
export class ReferrerComponent implements OnInit {
  @ViewChild(WebhookShippingComponent) webhookShipping!: WebhookShippingComponent;
  @ViewChild(ReferrerWhitelistComponent) referrerWhitelist!: ReferrerWhitelistComponent;
  @ViewChild(MobileKeyComponent) mobileKey!: MobileKeyComponent;

  isGetWebhook: boolean = true;

  constructor(
    private router: Router,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    this.isGetWebhook = this.profileService.getRoLevel() === 3;
    this.profileService.getRoLevel$().subscribe((level) => {
      this.isGetWebhook = level === 3;
    });
  }

  getListIP() {
    if (this.referrerWhitelist) {
      this.referrerWhitelist.getListIP();
    }
  }

  getListKey() {
    if (this.mobileKey) {
      this.mobileKey.getListKey();
    }
  }
}
